<template>
	<UIShModal class="modal" @close="$emit('close')">
		<div class="main">
			<UIShIcon
				role="button"
				name="x-close"
				class="close"
				aria-label="close"
				@click="$emit('close')"
			/>

			<b class="title">Оставьте заявку</b>
			<p class="description">
				Наш менеджер свяжется с вами в ближайшее время
			</p>

			<form @submit.prevent>
				<UIShInputText
					required
					lg
					:xl="1920"
					name="name"
					label="Имя"
					v-model="nameField.value.value"
					:error="nameField.errorMessage.value"
				/>

				<UIShInputText
					required
					lg
					:xl="1920"
					name="phone"
					label="Телефон"
					mask="+7(###) ###-##-##"
					v-model="phoneField.value.value"
					:error="phoneField.errorMessage.value"
				/>

				<UIShCheckbox
					label="Я соглашаюсь с Политикой конфиденциальности"
					v-model="checkField.value.value"
					lg
					xl1440
				/>

				<p
					v-if="submitResult.submitted"
					:class="[submitResult.success ? 'success' : 'error']"
				>
					{{ submitResult.message }}
				</p>

				<UIShButton
					type="submit"
					label="Отправить"
					fill
					md
					:xl="1920"
					:disabled="!canSubmit || loading.isLoading.value"
					@click.prevent="onSubmit"
				/>
			</form>
		</div>
	</UIShModal>
</template>

<script setup lang="ts">
import { API_RESPONSE } from '@/common/constants';

const $emit = defineEmits<{ (e: 'close'): void }>();

const triggers = useYmTriggers();
const loading = useLoadingIndicator();
const runtimeConfig = useRuntimeConfig();

const { handleSubmit, nameField, phoneField, checkField, canSubmit } =
	useOrderForm();

const submitResult = ref({ submitted: false, success: false, message: '' });

const onSubmit = handleSubmit(async () => {
	try {
		loading.start();
		submitResult.value.submitted = false;
		const utm = useNuxtApp().$getUtmData();

		const siteName =
			runtimeConfig.public.NUXT_PUBLIC_SITE_URL?.trim() || 'train73.pro';

		await $fetch('/api/local/siteCalls', {
			baseURL: runtimeConfig.public.API_URL,
			method: 'POST',
			body: {
				name: nameField.value.value,
				phone: phoneField.value.value,
				siteName,
				...utm
			}
		});

		triggers.hitCallMe();

		submitResult.value.submitted = true;
		submitResult.value.success = true;
		submitResult.value.message = API_RESPONSE.success;
		setTimeout(() => {
			$emit('close');
		}, 3000);
	} catch (error) {
		submitResult.value.submitted = true;
		submitResult.value.success = false;
		submitResult.value.message = API_RESPONSE.error;
	} finally {
		loading.finish();
	}
});
</script>

<style lang="scss" scoped>
.modal {
	::v-deep(.modal-wrapper) {
		align-items: flex-end;
	}

	::v-deep(.modal-content) {
		width: 100%;
	}
}

.main {
	width: 100%;
	position: relative;
	padding: 1.1111rem;
	padding-top: 1.7778rem;
	color: var(--color-gray950);
	border-top-left-radius: 1.1111rem;
	border-top-right-radius: 1.1111rem;
	background-color: var(--color-white);
}

.close {
	cursor: pointer;
	position: absolute;
	top: 0.6667rem;
	right: 0.6667rem;
	color: var(--color-gray500);
}

b {
	display: block;
	text-align: center;
	@include useFont(dxsb);
	text-transform: uppercase;
}

.description {
	text-align: center;
	@include useFont(tmdm);
	color: var(--color-gray600);
	margin-top: 0.222rem;
	max-width: 15.667rem;
	margin-inline: auto;
}

form {
	display: flex;
	flex-direction: column;
	gap: 0.889rem;
	margin-top: 1.778rem;
}

.error {
	@include useFont(tsmm);
	color: var(--color-error600);
}

.success {
	@include useFont(tsmm);
	color: var(--color-success700);
}

@include screen768 {
	.modal {
		::v-deep(.modal-wrapper) {
			align-items: center;
		}

		::v-deep(.modal-content) {
			width: auto;
		}
	}

	.main {
		width: 27.778rem;
		padding: 1.7778rem;
		border-radius: 1.1111rem;
	}

	b {
		@include useFont(dsmb);
	}

	.description {
		@include useFont(tlgm);
		margin-top: 0.667rem;
	}

	form {
		gap: 1.111rem;
	}
}
</style>
